/* Keep native fragment navigation and keyboard focus aligned with the site header. */
(() => {
  const bind = root => {
    if (root.dataset.chaletBound) return;
    root.dataset.chaletBound = 'true';
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#"]');
      if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (target && root.contains(target)) requestAnimationFrame(() => target.focus({preventScroll: true}));
    });
  };
  document.querySelectorAll('.cs-chalet').forEach(bind);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.cs-chalet').forEach(bind));
})();
